var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M810.667 490.666H315.734l226.133-226.133c17.067-17.067 17.067-42.667 0-59.733s-42.667-17.067-59.733 0L183.467 503.467c-4.267 4.267-8.533 8.533-8.533 12.8-4.267 8.533-4.267 21.333 0 34.133 4.267 4.267 4.267 8.533 8.533 12.8l298.667 298.667c8.533 8.533 21.333 12.8 29.867 12.8s21.333-4.267 29.867-12.8c17.067-17.067 17.067-42.667 0-59.733L315.735 576.001h494.933c25.6 0 42.667-17.067 42.667-42.667s-17.067-42.667-42.667-42.667z"}));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
